var EditCardComponent = /** @class */ (function () {
    function EditCardComponent() {
        this.Icon = "info_outline";
    }
    return EditCardComponent;
}());
export { EditCardComponent };
